const baseUrl = "https://torresowo.myftp.org:9993/stremio/";
const uuid = "41932a27-02ae-4b46-bc20-3c90087459b7";
const token = "eyJpdiI6Ikc1WjRnNkxIS2RQZGFqSHNEa0VVRVE9PSIsImVuY3J5cHRlZCI6ImhISmhDd2Q5b2ZENWVWbkhlaGJURHJTRlViYkpLYW1zSHVzVXdlZmxIN289IiwidHlwZSI6ImFpb0VuY3J5cHQifQ";

const fetchData = async (endpoint, params = {}) => {
    const url = new URL(`${baseUrl}/${uuid}/${token}/${endpoint}`);
    Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));

    const response = await fetch(url);

    if (!response.ok) {
        throw new Error(`Error fetching data: ${response.statusText}`);
    }

    return response.json();
};

export class AIOStreamAPI {

    static getMovieStreams = async (imdbId) => {
        const endpoint = `stream/movie/${imdbId}.json`;
        const data = await fetchData(endpoint);
        const streams = (data?.streams ?? []).filter(stream => !stream.name.includes("P2P") && !stream.name.includes("Collections"));
        return {streams};
    }

    static getSerieStreams = async (imdbId, season, episode) => {
        const endpoint = `stream/series/${imdbId}:${season}:${episode}.json`;
        const data = await fetchData(endpoint);
        const streams = (data?.streams ?? []).filter(stream => !stream.name.includes("P2P") && !stream.name.includes("Collections"));
        return {streams};
    }

}
